import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import router from '@/router';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '@/services/integration/enums';


export default /*@__PURE__*/_defineComponent({
  __name: 'Redirect2',
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

// Data.
// Event handlers.
const nexeeRedirect = async () => {
  if (brandService.getName() === Brand.HIS) {
    setTimeout(() => {
      window.location.href = 'https://nexee.au?from=his';
    }, 22000);
  } else {
    router.push('/');
  }
};

nexeeRedirect();

return (_ctx: any,_cache: any) => {
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, {
    style: {"height":"80vh"},
    class: "bg-white h-screen text-center py-10 justify-center items-center flex flex-col px-4"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("h2", { class: "font-gotham-medium font-bold text-xl pt-2" }, "Harbour ISP is now Nexee. Customers can use existing log in details for your internet account.", -1),
      _createElementVNode("h2", { class: "font-gotham-medium font-bold text-xl pt-4" }, [
        _createTextVNode(" You will be redirected to Nexee in 20 seconds or "),
        _createElementVNode("a", {
          class: "underline",
          href: "https://nexee.au?from=his"
        }, "click here.")
      ], -1)
    ])),
    _: 1,
    __: [0]
  }))
}
}

})